import { RootState } from "../root/redux.types";

export const selectSystem = (state: RootState) => state.system;
